import { render, staticRenderFns } from "./ServiceScope.vue?vue&type=template&id=e55fa340&scoped=true"
import script from "./ServiceScope.vue?vue&type=script&lang=js"
export * from "./ServiceScope.vue?vue&type=script&lang=js"
import style0 from "./ServiceScope.vue?vue&type=style&index=0&id=e55fa340&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55fa340",
  null
  
)

export default component.exports